import React from 'react'
import axios from 'axios'

export const AUTH_KEY = '__AUTH_KEY__'
export const LOGINNAME = '__LoginName__'
export const isBrowser = typeof window !== 'undefined'

const isChinese = process.env.GATSBY_LOCALE === 'zh'

export function useGetInfo() {
  const [loginName, setLoginName] = React.useState(
    isBrowser ? window.localStorage.getItem(LOGINNAME) || '' : '',
  )
  const [hasPermission, setHasPermission] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const redirect = React.useCallback(() => {
    if (isBrowser) {
      window.location.href = `${
        isChinese ? process.env.GATSBY_REDIRECT : process.env.GATSBY_REDIRECT_EN
      }?redirect_uri=${window.encodeURIComponent(window.location.href)}`
    }
  }, [])

  const request = React.useCallback(
    (token) => {
      setLoading(true)
      axios
        .post(
          `${isChinese ? process.env.GATSBY_API_URL : process.env.GATSBY_API_URL_EN}`,
          {},
          {
            headers: {
              token,
              'Content-Type': 'application/json; charset=utf-8',
              channel: 1,
              version: '1.0.0',
              signature: 'rayvision2017',
            },
          },
        )
        .then((res) => {
          if (res.data.result) {
            setLoginName(res.data?.data?.loginName)
            setHasPermission(
              res.data?.data?.dicts?.reduce((obj, cur) => {
                obj[cur.dictCode] = cur.dictData
                return obj
              }, {}),
            )
            window.localStorage.setItem(LOGINNAME, res.data?.data.loginName)
          } else {
            redirect()
          }
        })
        .finally(() => setLoading(false))
    },
    [redirect],
  )

  React.useEffect(() => {
    if (isBrowser) {
      let token = window.location.href.split('rsa=')[1]
      if (token) {
        window.localStorage.setItem(AUTH_KEY, token)
        window.history.pushState(
          '',
          '',
          window.location.origin +
            window.location.pathname +
            window.location.hash.split('?rsa=')[0],
        )
        request(token)
      } else {
        const tokenFromLocal = window.localStorage.getItem(AUTH_KEY)
        if (tokenFromLocal) {
          request(tokenFromLocal)
        } else {
          redirect()
        }
      }
    }
    // eslint-disable-next-line
  }, [])

  return {
    redirect,
    request,
    loginName,
    loading,
    hasPermission,
  }
}
